import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import authService from '../../services/authService';
import './AdminStyles.css';

function AdminLogin() {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loginError, setLoginError] = useState('');
  const navigate = useNavigate();
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    
    // Clear error when field is edited
    if (errors[name]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: null
      }));
    }
  };
  
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.username) {
      newErrors.username = 'Username is required';
    }
    
    if (!formData.password) {
      newErrors.password = 'Password is required';
    }
    
    return newErrors;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationErrors = validateForm();
    
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    
    setIsSubmitting(true);
    setLoginError('');
    
    try {
      const data = await authService.adminLogin({
        username: formData.username,
        password: formData.password
      });
      
      // Store admin data from the response
      localStorage.setItem('adminToken', data.token);
      localStorage.setItem('adminId', data.admin.id);
      localStorage.setItem('adminName', data.admin.username);
      localStorage.setItem('adminEmail', data.admin.email);
      localStorage.setItem('adminIsSuperAdmin', data.admin.is_super_admin);
      localStorage.setItem('adminIsViewOnly', data.admin.is_view_only);
      localStorage.setItem('adminTokenExpires', data.expires);
      
      // Redirect to admin dashboard
      navigate('/admin/dashboard');
      
    } catch (error) {
      console.error('Login error:', error);
      if (error.response && error.response.data && error.response.data.error) {
        setLoginError(error.response.data.error);
      } else {
        setLoginError('Invalid username or password');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-form-container">
        <div className="admin-login-header">
          <h1>BVA Admin</h1>
          <p>Login to access the administration panel</p>
        </div>
        
        {loginError && (
          <div className="admin-alert admin-alert-danger">
            {loginError}
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="admin-form">
          <div className="admin-form-group">
            <label htmlFor="username">Username</label>
            <input 
              type="text" 
              id="username" 
              name="username" 
              value={formData.username}
              onChange={handleChange}
              className={errors.username ? 'admin-input-error' : ''}
            />
            {errors.username && (
              <div className="admin-error-message">{errors.username}</div>
            )}
          </div>
          
          <div className="admin-form-group">
            <label htmlFor="password">Password</label>
            <input 
              type="password" 
              id="password" 
              name="password" 
              value={formData.password}
              onChange={handleChange}
              className={errors.password ? 'admin-input-error' : ''}
            />
            {errors.password && (
              <div className="admin-error-message">{errors.password}</div>
            )}
          </div>
          
          <button 
            type="submit" 
            className="admin-btn admin-btn-primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
        <div className="admin-login-footer">
          <Link to="/" className="admin-link">Back to Website</Link>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;